import { apiPost, API_ENDPOINTS } from "../utils/apiUtils";

/**
 * Organization Event Service
 * Handles organization events and garage management
 */
const OrganizationEventService = {
  // Organization Events
  /**
   * Get all organization events
   * @param {Object} filters - Filter parameters
   * @returns {Promise} API response
   */
  async getAllOrganizationEvents(filters) {
    return apiPost(API_ENDPOINTS.ORGANIZATIONS.GET_EVENTS, filters);
  },

  /**
   * Get organization event details
   * @param {Object} eventData - Event identifier
   * @returns {Promise} API response
   */
  async getOrganizationEventsDetails(eventData) {
    return apiPost(API_ENDPOINTS.ORGANIZATIONS.GET_DETAILS, eventData);
  },

  /**
   * Update organization event details
   * @param {Object} eventData - Event update data
   * @returns {Promise} API response
   */
  async updateOrganizationEventsDetails(eventData) {
    return apiPost(API_ENDPOINTS.ORGANIZATIONS.UPDATE_EVENTS, eventData);
  },

  // Garage Management
  /**
   * Get all garages
   * @param {Object} filters - Filter parameters
   * @returns {Promise} API response
   */
  async getAllListGarages(filters) {
    return apiPost(API_ENDPOINTS.GARAGES.GET_ALL, filters);
  },

  /**
   * Delete garage
   * @param {Object} garageData - Garage deletion data
   * @returns {Promise} API response
   */
  async deleteGarage(garageData) {
    return apiPost(API_ENDPOINTS.GARAGES.DELETE, garageData);
  },
};

export default OrganizationEventService;
